import { useContext, useEffect, useState } from "react";
import { AssetCard } from "./AssetCard";
import ExpandAssetModal from "./ExpandAssetModal";
import AssetPagination from "./AssetPagination";
import { fetchAssets } from "@ts/utils";
import * as Sentry from "@sentry/react";
import { mainContext } from "@ts/constants";
import {
    IAssetExpandProps,
    IMainContext,
    IPopulateAssetGrid,
} from "@ts/common-types";

const PopulateAssetGrid: React.FC<IPopulateAssetGrid> = ({
    assetClickHandler,
    assetData,
    setAssetResponse,
}) => {
    const {
        pageLimit,
        totalPages,
        setPageLimit,
        setActivePage,
        setTotalPages,
        isAssetUpload,
        activePage,
        selectedImageFilter,
        setSelectedImageFilter,
    } = useContext<IMainContext>(mainContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [expandedAssetProps, setExpandedAssetProps] =
        useState<IAssetExpandProps>();

    const onAssetExpandClickHandler = ({
        fileExt,
        fileMime,
        fileURL,
        fileSrc,
        fileName,
    }: IAssetExpandProps) => {
        setShow(true);
        setExpandedAssetProps({
            fileName,
            fileExt,
            fileMime,
            fileURL,
            fileSrc,
        });
    };

    const CustomLoader = () => {
        return (
            <>
                <div className="assets-loader-container">
                    <i className="spinner-border assets-loader" />
                    <div className="fs-2">Loading...</div>
                </div>
            </>
        );
    };

    useEffect(() => {
        if (isAssetUpload) {
            const data = {
                activePage,
                pageLimit,
                selectedImageFilter,
            };

            setIsLoading(true);
            fetchAssets(data)
                .then((response) => {
                    const { pageCount } = response.meta.pagination;
                    setTotalPages(pageCount);
                    setAssetResponse(response);
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                    Sentry.captureException(error);
                });
        }
        // eslint-disable-next-line
    }, [isAssetUpload, pageLimit, selectedImageFilter, activePage]);

    return (
        <>
            {isLoading ? (
                <CustomLoader />
            ) : (
                <>
                    <div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <div className="d-flex justify-content-end"
                                style={{
                                    right: "1rem",
                                    marginTop: "1rem",
                                    flex: 1
                                }}
                            >
                                    <span>Filter By : &nbsp;</span>
                                    <select
                                        id="image_filter"
                                        className="border bg-light text-dark"
                                        value={selectedImageFilter}
                                        onChange={(e) => {
                                            setActivePage(1);
                                            setSelectedImageFilter(e.target.value);
                                        }}
                                        style={{ fontSize: "12px" }}
                                    >
                                        <option value="all">All</option>
                                        <option value="logo">Logo</option>
                                        <option value="creative_static">
                                            Creative Asset
                                        </option>
                                        <option value="creative_video">
                                            Creative Video
                                        </option>
                                    </select>
                            </div>
                        </div>

                        <div
                            className="row row-cols-5 pb-3 d-flex mt-3"
                            id="image-row"
                        >
                            {assetData.length >= 1 ? (
                                assetData.map((res) => (
                                    <AssetCard
                                        assetResponse={res}
                                        key={res.id}
                                        assetClickHandler={assetClickHandler}
                                        onAssetExpandClickHandler={
                                            onAssetExpandClickHandler
                                        }
                                    />
                                ))
                            ) : (
                                <div
                                    style={{
                                        fontSize: "2.5rem",
                                        width: "35rem",
                                        margin: "10% auto",
                                        color: "#B2B2B2",
                                        textAlign: "center",
                                    }}
                                >
                                    No matching items found
                                </div>
                            )}
                        </div>
                    </div>

                    {totalPages !== 1 ? (
                        <AssetPagination {...{ pageLimit, setPageLimit }} />
                    ) : null}
                </>
            )}
            {show && (
                <ExpandAssetModal {...{ show, setShow, expandedAssetProps }} />
            )}
        </>
    );
};

export default PopulateAssetGrid;
